export const ADMIN_EMAILS = [
  'barzoiu.alexandru@gmail.com',
  'office@extracta.ai',
  'alexraducu03@gmail.com',
];

export const isAdminEmail = (email) =>
  Boolean(email && ADMIN_EMAILS.includes(email));

export const isNonProductionEnvironment = () =>
  process.env.REACT_APP_ENV !== 'production';

export const canUseAdminDevTools = (email) => isAdminEmail(email);
